module.exports = __webpack_public_path__ + "static/media/tulips4.531ffe4d.png";